import { Box, Dialog, DialogContent, Typography } from "@mui/material"
import { jobOrderColNm } from "constants/jobOrderConstant"
import { BoxFC } from "components/BoxCustom"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import React, { useCallback, useMemo } from "react"
import { addIdForDataGrid } from "utils"
import { selectJobOrderColumns } from "./columns"

/**
 * Job order picker for when a search (e.g. by container no.) returns more than one hit.
 * Pass the search result rows in `jobOrders`; clicking the JobOrdId or ContNo cell
 * calls `onSelect` with the whole picked row and closes the dialog.
 */
const SelectJobOrderDialog = ({ dialogOpen, setDialogOpen, jobOrders = [], onSelect, title = "เลือกใบงาน" }) => {

  const rows = useMemo(() => addIdForDataGrid(jobOrders, "JobOrdId"), [jobOrders])

  const handleCellClick = useCallback((params) => {
    if (!["JobOrdId", "ContNo"].includes(params.field)) return
    onSelect?.(params.row)
    setDialogOpen(false)
  }, [onSelect, setDialogOpen])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='lg'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)} title={title} onDeleteClick={null} />
      <DialogContent>
        <BoxFC pt={2} gap={1}>
          <Typography color="text.secondary">
            พบ {rows.length} ใบงาน กรุณาเลือกโดยคลิกที่ {jobOrderColNm.JobOrdId} หรือ {jobOrderColNm.ContNo}
          </Typography>
          <Box height={450}>
            <DataGridCellExpand
              hideFooter
              rows={rows}
              columns={selectJobOrderColumns}
              onCellClick={handleCellClick}
            />
          </Box>
        </BoxFC>
      </DialogContent>
      <DialogFooter cancelText="ปิด" handleDialogClose={() => setDialogOpen(false)} />
    </Dialog>
  )
}

export default React.memo(SelectJobOrderDialog)
